import { ActivatedRoute, Router } from '@angular/router';

export const reloadContext = (router: Router, route: ActivatedRoute) => {
  window.location.reload();
};

